import React from 'react';
import { normalizePhaseLinkUrl } from '@hooks/projects/projectHelpers';

export const LINK_URL_EXAMPLE_HELP = (
    <div style={{ fontSize: 12, lineHeight: 1.35 }}>
        <div
            style={{
                fontFamily:
                    'ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace',
            }}
        >
            https://example.com
        </div>
    </div>
);

export function normalizeUrlOnFirstType(nextValue, prevValue) {
    const next = typeof nextValue === 'string' ? nextValue : '';
    const prev = typeof prevValue === 'string' ? prevValue : '';
    if (!next) return next;

    // Only auto-prefix when the user starts typing into an empty field.
    if (prev) return next;

    // If they already typed a scheme (http:, https:, mailto:, etc.) or protocol-relative URL, keep it.
    const hasScheme = /^[a-zA-Z][a-zA-Z\d+\-.]*:/.test(next);
    if (hasScheme || next.startsWith('//')) return next;

    // Default to https:// when user types a bare domain.
    return `https://${next}`;
}

export function validateLinkUrlInput(rawUrl) {
    const raw = typeof rawUrl === 'string' ? rawUrl.trim() : '';
    if (!raw) return { ok: false, message: 'Enter URL' };

    // UI rule: require explicit https://
    if (!/^https:\/\//i.test(raw)) {
        return { ok: false, message: 'URL must start with "https://"' };
    }

    const normalized = normalizePhaseLinkUrl(raw);
    if (!normalized) return { ok: false, message: 'Enter a valid URL (e.g. https://example.com)' };

    // Strict-ish http(s) URL validity.
    try {
        const u = new URL(normalized);
        const protocol = (u.protocol || '').toLowerCase();
        if (protocol !== 'https:') {
            return { ok: false, message: 'URL must use https://' };
        }
        const host = (u.hostname || '').trim().toLowerCase();
        if (!host) return { ok: false, message: 'Enter a valid URL (e.g. https://example.com)' };
        if (host === 'localhost') return { ok: true, normalized };
        if (/^\d{1,3}(\.\d{1,3}){3}$/.test(host)) return { ok: true, normalized };
        if (!host.includes('.') || host.endsWith('.')) {
            return { ok: false, message: 'Enter a valid URL (e.g. https://example.com)' };
        }
        const parts = host.split('.').filter(Boolean);
        const tld = parts[parts.length - 1] || '';
        if (tld.length < 2) return { ok: false, message: 'Enter a valid URL (e.g. https://example.com)' };
        return { ok: true, normalized };
    } catch {
        return { ok: false, message: 'Enter a valid URL (e.g. https://example.com)' };
    }
}

